module.exports = __webpack_public_path__ + "static/american-prison-014f363e071bd31169d69916f37a7799.jpg";